<template>
  <ul :class="{ 'lg:grid lg:grid-cols-3': !stacked }">
    <li
      v-for="(interest, index) in areasOfInterestList"
      :key="`interest-${index}`"
      class="flex items-center mt-2 *:text-neutral-900 space-x-4 lg:mt-4"
    >
      <fa
        :icon="['fal', 'check']"
        class="text-base"
      />
      <p>{{ $t(`search.areas-of-interest-type.${interest.name}`) }}</p>
    </li>
  </ul>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheck } from '@fortawesome/pro-light-svg-icons';

library.add(faCheck);

export default {
  name: 'VetsterAreasOfInterest',

  props: {
    areasOfInterest: {
      type: Array,
      default: () => [],
    },
    limit: {
      type: Number,
      default: 0,
    },
    stacked: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    areasOfInterestList() {
      if (this.limit > 0) {
        return this.areasOfInterest.slice(0, this.limit);
      }

      return this.areasOfInterest;
    },
  },
};
</script>
